import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InlineEditDialogComponent } from '../inline-edit/inline-edit-dialog.component';

@Component({
  selector: 'app-password',
  templateUrl: './password-dialog.component.html',
  styleUrls: ['./password-dialog.component.scss']
})
export class PasswordDialogComponent {
  form!: FormGroup;
  error = '';

  // Secret code (move to env/config in production)
  private readonly SECRET_CODE = 'letmein123';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { key: string; currentText: string; targetElement: HTMLElement },
    private dialogRef: MatDialogRef<PasswordDialogComponent>,
    private dialog: MatDialog,
    public fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      code: ['', Validators.required]
    });
  }

  onSubmit(): void {
    const enteredCode = this.form.value.code;
    if (enteredCode === this.SECRET_CODE) {
      this.dialogRef.close();
      this.dialog.open(InlineEditDialogComponent, {
        width: '400px',
        data: this.data
      });
    } else {
      this.error = 'Incorrect code. Please try again.';
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
